<template>
  <el-container class="site-config-container">
    <el-main>
      <el-row>
        <el-col :xs="24" :sm="24" :md="20" :lg="18" :xl="16">
          <el-card class="box-card" shadow="never">
            <div slot="header" class="card-header">
              <span class="header-title">
                <i class="el-icon-setting" /> 站点配置
              </span>
              <el-button
                type="primary"
                plain
                size="mini"
                icon="el-icon-refresh"
                @click="getData"
              >
                刷新
              </el-button>
            </div>

            <!-- 配置列表表格 -->
            <el-table
              :data="siteConfigList"
              border
              stripe
              style="width: 100%"
              header-cell-class-name="table-header-gray"
            >
              <el-table-column
                label="No"
                type="index"
                width="60"
                align="center"
              />

              <!-- 配置键 -->
              <el-table-column
                prop="propKey"
                label="配置键 (propKey)"
                min-width="200"
              >
                <template slot-scope="scope">
                  <el-tag size="small" type="info" effect="plain" class="key-tag">
                    {{ scope.row.propKey }}
                  </el-tag>
                </template>
              </el-table-column>

              <!-- 配置值 -->
              <el-table-column
                prop="propValue"
                label="配置值 (propValue)"
                min-width="200"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.propValue !== null && scope.row.propValue !== ''">
                    {{ scope.row.propValue }}
                  </span>
                  <el-tag v-else size="mini" type="info">空</el-tag>
                </template>
              </el-table-column>

              <!-- 配置描述 -->
              <el-table-column
                prop="propDesc"
                label="配置描述 (propDesc)"
                min-width="220"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.propDesc !== null && scope.row.propDesc !== ''">
                    {{ scope.row.propDesc }}
                  </span>
                  <el-tag v-else size="mini" type="info">空</el-tag>
                </template>
              </el-table-column>

              <!-- 更新时间 -->
              <el-table-column
                prop="updateTime"
                label="更新时间"
                width="160"
                align="center"
              />

              <!-- 操作列 -->
              <el-table-column
                label="操作"
                width="100"
                align="center"
                fixed="right"
              >
                <template slot-scope="scope">
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-edit"
                    @click="handleEdit(scope.row)"
                  >
                    编辑
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </el-col>
      </el-row>

      <!-- 编辑配置弹窗 -->
      <el-dialog
        title="修改站点配置"
        :visible.sync="dialogVisible"
        width="520px"
        :close-on-click-modal="false"
        @closed="handleDialogClosed"
      >
        <el-form
          ref="configForm"
          :model="form"
          :rules="rules"
          label-width="120px"
          size="small"
        >
          <el-form-item label="配置键 (propKey)">
            <el-input v-model="form.propKey" disabled />
          </el-form-item>

          <el-form-item label="配置值 (propValue)" prop="propValue">
            <el-input
              v-model="form.propValue"
              placeholder="请输入配置值（可为空）"
              clearable
            />
          </el-form-item>

          <el-form-item label="配置描述 (propDesc)" prop="propDesc">
            <el-input
              v-model="form.propDesc"
              type="textarea"
              :rows="3"
              placeholder="请输入配置描述（可为空）"
              clearable
            />
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible = false">取 消</el-button>
          <el-button
            type="primary"
            size="small"
            :loading="submitting"
            @click="submitForm"
          >
            确 定
          </el-button>
        </div>
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
import { userMixin } from 'assets/js/mixin'
import { getSiteConfigs, updateSiteConfig } from '@/api/admin'

export default {
  name: 'AdminSiteConfig',
  mixins: [userMixin],
  data() {
    return {
      siteConfigList: [],
      dialogVisible: false,
      submitting: false,
      form: {
        id: null,
        propKey: '',
        propValue: '',
        propDesc: ''
      },
      // 允许为空字符串，仅作基础数据格式过滤
      rules: {
        propValue: [
          { transform: value => value ? value.trim() : value }
        ],
        propDesc: [
          { transform: value => value ? value.trim() : value }
        ]
      }
    }
  },
  created() {
    document.title = '站点配置'
    this.getData()
  },
  mounted() {},
  methods: {
    getData() {
      this.getSiteConfigsWrapper()
    },
    getSiteConfigsWrapper() {
      getSiteConfigs().then(resp => {
        if (resp.code === 0) {
          this.siteConfigList = resp.data || []
        } else {
          this.$message.error(resp.msg)
        }
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    // 打开编辑弹窗并回显数据（空值回退为空字符串，防止受控制属性报错）
    handleEdit(row) {
      this.form = {
        id: row.id,
        propKey: row.propKey,
        propValue: row.propValue ?? '',
        propDesc: row.propDesc ?? ''
      }
      this.dialogVisible = true
    },
    // 提交编辑表单
    submitForm() {
      this.$refs.configForm.validate(valid => {
        if (!valid) return
        this.updateSiteConfigWrapper()
      })
    },
    updateSiteConfigWrapper() {
      this.submitting = true
      const payload = {
        id: this.form.id,
        propKey: this.form.propKey,
        propValue: this.form.propValue,
        propDesc: this.form.propDesc
      }
      updateSiteConfig(payload).then(resp => {
        if (resp.code === 0) {
          this.$message.success('更新成功')
          this.dialogVisible = false
          this.getSiteConfigsWrapper()
        } else {
          this.$message.error(resp.msg)
        }
      }).catch(error => {
        this.$message.error(error.message)
      }).finally(() => {
        this.submitting = false
      })
    },
    // 弹窗关闭后清理表单校验痕迹
    handleDialogClosed() {
      if (this.$refs.configForm) {
        this.$refs.configForm.resetFields()
      }
    }
  }
}
</script>

<style scoped>
.site-config-container {
  padding: 16px;
  background-color: #f5f7fa;
  min-height: 100vh;
  box-sizing: border-box;
}

.box-card {
  border-radius: 8px;
  border: none;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2d3d;
}

.key-tag {
  font-family: monospace;
  font-weight: 600;
}

:deep(.table-header-gray) {
  background-color: #f8f9fa !important;
  color: #606266;
  font-weight: 600;
}
</style>
